import React, { useEffect, useState } from 'react';
import BlankTemplate from 'components/Templates/BlankTemplate';
import ConfirmEmployee from 'components/Organisms/Employee/EmployeeRecord/ActionList/ConfirmEmployee';
import { useThunk } from 'hooks/useThunk';
import { fetchConfirmEmployee } from 'store';
import { Typography, Box, Skeleton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { confirmEmployeeAction } from 'api/employees';
import dayjs from 'dayjs';
import useToast from 'components/Provider/useToast';

const ConfirmEmployeePage = () => {
  const addToast = useToast();
  const navigate = useNavigate();
  const { userId } = useParams();

  const [loading, setLoading] = useState(false);
  const [getConfirmEmployee, isLoadingConfirmEmployee, loadingConfirmEmployeeError] = useThunk(fetchConfirmEmployee);

  useEffect(() => {
    const query = new URLSearchParams({});
    query.append('id', userId);
    getConfirmEmployee(query);
  }, [userId, getConfirmEmployee]);

  const { confirmEmployee } = useSelector((state) => state.employees);

  const employeeData = {
    supervisor: confirmEmployee?.supervisor?.fullName,
    department: confirmEmployee?.department?.name,
    designation: confirmEmployee?.designation?.name,
    location: confirmEmployee?.location?.name,
  };

  const handleSubmit = async ({ startDate, notes, attachments }) => {
    const newStartDate = startDate ? dayjs(startDate).format('MM/DD/YYYY') : '';
    const bodyFormData = new FormData();
    const newNotes = notes || '';
    bodyFormData.append('empID', confirmEmployee?.user?.employeeId);
    bodyFormData.append('effectiveStartDate', newStartDate);
    bodyFormData.append('CurrentAction', 'SaveAndSubmit');
    bodyFormData.append('notes', newNotes);
    bodyFormData.append('attachment', attachments || '');

    try {
      setLoading(true);
      const response = await confirmEmployeeAction(bodyFormData);
      if (response?.data?.status === 'SUCCESS') {
        addToast({ type: 'success', title: 'SUCCESS', message: response?.data?.message });
        navigate(`/company/employee/view/${userId}`);
      } else {
        addToast({ type: 'error', title: 'ERROR', message: response?.data?.message });
      }
    } catch (error) {
      addToast({ type: 'error', title: 'ERROR', message: error?.response?.data?.message || error?.message });
    } finally {
      setLoading(false);
    }
  };

  if (loadingConfirmEmployeeError !== null) {
    return (
      <Typography variant="h6">
        {loadingConfirmEmployeeError?.message || `Error while loading current details for employee id : ${userId}.`}
      </Typography>
    );
  }

  const breadcrumbData = [
    { id: 1, name: 'Employee List', path: '/company/employee/employees-list', isActive: false },
    { id: 2, name: 'Employee Records', path: `/company/employee/view/${userId}`, isActive: false },
    { id: 2, name: 'Confirm Employee', isActive: true },
  ];

  return isLoadingConfirmEmployee ? (
    <Box sx={{ p: 4 }}>
      <Skeleton height={70} />
      <Skeleton />
      <Skeleton />
    </Box>
  ) : (
    <BlankTemplate
      pageHeading={`Confirm Employee: ${get(confirmEmployee, 'fullName', '')} (${get(
        confirmEmployee,
        'profile.employeeId',
        'NA',
      )})`}
      breadcrumbData={breadcrumbData}
      padding="3rem"
    >
      <ConfirmEmployee employeeData={employeeData} handleSubmit={handleSubmit} loading={loading} />
    </BlankTemplate>
  );
};

export default ConfirmEmployeePage;
